import type { SVGProps } from "react";

export default function OtherIssueIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.16602 18.3335V11.6668M4.16602 11.6668V3.33349M4.16602 11.6668L6.22491 11.2551C7.60035 10.98 9.0261 11.1108 10.3284 11.6318C11.7398 12.1963 13.293 12.3017 14.7677 11.9331L14.8511 11.9122C15.3395 11.7902 15.5711 11.2309 15.3121 10.7992L14.0116 8.63166C13.727 8.15735 13.5847 7.9202 13.5509 7.66225C13.5369 7.55465 13.5369 7.44567 13.5509 7.33807C13.5847 7.08012 13.727 6.84297 14.0116 6.36867L15.077 4.59292C15.3559 4.12816 14.9336 3.55826 14.4078 3.68971C13.1671 3.99988 11.8603 3.91118 10.6728 3.43623L10.3284 3.29847C9.0261 2.77752 7.60035 2.64662 6.22491 2.92172L4.16602 3.33349M4.16602 3.33349V1.66682"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
